import { FC, useCallback } from "react";
import { Alert, Button, Stack } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";

export const BillingExplorerSavingOpportunitiesDataGridToolbarLeftSide: FC =
  ({}) => {
    const allOpportunitiesClickHandler = useCallback(() => {
      window.open("/recommendations/savings-opportunities", "_blank");
    }, []);

    return (
      <Alert
        severity="info"
        sx={{
          alignItems: "center",
          "& .MuiAlert-action": { p: 0, pl: 2 },
          overflow: "hidden",
        }}
        action={
          <Button
            color="inherit"
            size="small"
            endIcon={<OpenInNewIcon fontSize="small" />}
            sx={{ whiteSpace: "nowrap", color: "primary.main" }}
            variant="text"
            disableRipple
            onClick={allOpportunitiesClickHandler}
          >
            See all opportunities
          </Button>
        }
      >
        <Stack overflow="hidden">
          <TypographyWithTooltip
            variant="caption"
            title="The list below shows all savings opportunities that match your
            current report filters."
          />
        </Stack>
      </Alert>
    );
  };
